import React from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from 'Components/Icon';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const SplittableColumn = ColumnTree.defineNode('splittable', () => ({
  title: (
    <FormattedMessage
      id="marketplace-table-heading-splittable"
      defaultMessage="Splittable"
    />
  ),
  key: 'splittable',
  className: 'col-splittable',
  render: (_text, record) => (
    <div className="td-content">
      <span className="tw tw:inline-flex tw:items-center tw:gap-1">
        <Icon name={record.splittable ? 'check' : 'block'} size="small" />
        {record.splittable ? (
          <FormattedMessage id="splittable" defaultMessage="Splittable" />
        ) : (
          <FormattedMessage
            id="not-splittable"
            defaultMessage="Not splittable"
          />
        )}
      </span>
    </div>
  ),
}));
